import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
// import { TranslateService } from "@mangosoft/mango-layout";
import { Subject } from 'rxjs';
import { takeUntil, tap } from 'rxjs/operators';
import { OptionsFilter } from '../../interfaces/filter-list.interface';

@Component({
  selector: 'app-filter',
  templateUrl: './filter.component.html',
  styleUrls: ['./filter.component.scss'],
})
export class FilterComponent implements OnInit {
  @Input() options: OptionsFilter[] = [
    { value: 'path', label: 'Path' },
    { value: 'name', label: 'Name' },
  ];
  @Input() widh: number = 681;
  @Output() filterSelected = new EventEmitter<OptionsFilter[]>();
  selectable = true;
  removable = true;
  addOnBlur = true;
  unsubscribe$ = new Subject();
  chips: OptionsFilter[] = [];
  data = '';
  placeholder = 'Search';

  constructor() {}

  ngOnInit(): void {
    this.getTranslate();
  }

  getTranslate() {
    // this.translateService
    //   .init("AccessControl")
    //   .pipe(
    //     tap((data) => {
    //       this.placeholder = data.components.subSidebar.search;
    //     }),
    //     takeUntil(this.unsubscribe$)
    //   )
    //   .subscribe();
  }

  activeFilter(option: OptionsFilter) {
    this.chips = this.chips.filter((dat) => dat.name !== option.name);
    if (this.data.length !== 0) {
      this.chips.push({ ...option, selected: this.data });
      this.filterSelected.emit(this.chips);
    }
    this.data = '';
  }
  removeItem(item: OptionsFilter) {
    this.chips = this.chips.filter((itemChip) => itemChip.name !== item.name);
    this.filterSelected.emit(this.chips);
  }

  calcWidth() {
    return { width: `calc(100vw - ${this.widh}px) ` };
  }
}
